import { ThemeOptions } from "@mui/material/styles";

export const formHelperTextOverrides: ThemeOptions["components"] = {
	MuiFormHelperText: {
		styleOverrides: {
			root: ({ theme }) => ({
				fontSize: theme.typography.pxToRem(12),
				lineHeight: "133.333%",
			}),
		},
	},
};
